// 奖学金
// 所有page请放在 /user/page/scholarships下
const SeriesCourse = () => import('../page/scholarships/seriesCourse/index.page');
const ClockCalender = () => import('../page/scholarships/clockCalender/index.page');
const Detail = () => import('../page/scholarships/detail/index.page');
const Success = () => import('../page/scholarships/paysuccess/index.page');
const ScholarshipsIndex = () => import('../page/scholarships/index/index.page');
const MyScholarships = () => import('../page/scholarships/myScholarships/index.page');
const VerifiedStatus = () => import('../page/scholarships/verifiedStatus/index.page');
const Verified = () => import('../page/scholarships/verified/index.page');
const VerifiedSuccess = () => import('../page/scholarships/verifiedSuccess/index.page');
const Like = () => import('../page/scholarships/like/index.page');
const MediaCourse = () => import('../page/scholarships/mediaCourse');

export default [
  {
    path: '/scholarships/index',
    name: 'ScholarshipsIndex',
    meta: {
      pageTitle: '奖学金计划',
      requiresAuth: false        // 是否需要登录
    },
    component: ScholarshipsIndex
  },
  {
    path: '/scholarships/myScholarships',
    name: 'MyScholarships',
    meta: {
      pageTitle: '我的奖学金计划',
      requiresAuth: true,        // 是否需要登录
      authType: 'user'      // 是否需要登录
    },
    component: MyScholarships
  },
  {
    path: '/scholarships/verifiedStatus',
    name: 'VerifiedStatus',
    meta: {
      pageTitle: '实名认证',
      requiresAuth: true,
      authType: 'user'      // 是否需要登录
    },
    component: VerifiedStatus
  },
  {
    path: '/scholarships/verified',
    name: 'Verified',
    meta: {
      pageTitle: '实名认证',
      requiresAuth: true,
      authType: 'user'       // 是否需要登录
    },
    component: Verified
  },
  {
    path: '/scholarships/verifiedSuccess',
    name: 'VerifiedSuccess',
    meta: {
      pageTitle: '实名认证',
      requiresAuth: false,
      authType: 'user'       // 是否需要登录
    },
    component: VerifiedSuccess
  },
  {
    path: '/scholarships/series/:planId(planId-\\d+)/:liveId(courseId-\\d+)',
    name: 'seriesCourse',
    meta: {
      pageTitle: '奖学金系列课',
      requiresAuth: false
    },
    component: SeriesCourse
  },
  {
    path: '/scholarships/clockCalender/:activityid',
    name: 'clockCalender',
    meta: {
      pageTitle: '打卡日历',
      requiresAuth: false
    },
    component: ClockCalender
  },
  {
    path: '/scholarships/detail/:id',
    name: 'detail',
    meta: {
      pageTitle: '奖学金',
      requiresAuth: false         // 是否需要登录
    },
    component: Detail
  },
  {
    path: '/scholarships/success',
    name: 'success',
    meta: {
      pageTitle: '支付成功',
      requiresAuth: false        // 是否需要登录
    },
    component: Success
  },
  {
    path: '/scholarships/like/:planId(\\d+)/:recordId(\\d+)',
    name: 'like',
    meta: {
      pageTitle: '解锁复活卡',
      requiresAuth: true,
      authType: 'user'       // 是否需要登录
    },
    component: Like
  },
  // 课程详情页
  {
    path: '/scholarships/course/:liveId',
    name: 'MediaCourse',
    meta: {
      pageTitle: '课程详情',
      requiresAuth: false         // 是否需要登录
    },
    redirect: (to) => {
      // 方法接收 目标路由 作为参数
      // return 重定向的 字符串路径/路径对象
      return { name: 'MediaCourseNew', params: { activityId: to.query.activityId, liveId: to.params.liveId }, query: { parentid: to.query.parentid } };
    }
  },
  {
    path: '/scholarships/course/:activityId/:liveId',
    name: 'MediaCourseNew',
    meta: {
      pageTitle: '课程详情',
      requiresAuth: false         // 是否需要登录
    },
    component: MediaCourse
  }
];



// WEBPACK FOOTER //
// ./src/user/router/scholarships.js